import { keys } from '@rehaje/shared'

import { SchemaQueryDefinition } from './SchemaDefinition'
import { QueryDefinition } from './TypedDefinition'
import { QueryNode } from './TypedNode'
import { QueryModel } from './ViewModel'

import type {
  PluginVisitors,
  RehajePlugin,
  RequiredPluginVisitors,
  TypedDefinitionConstructor,
  TypedNodeConstructor
} from '@rehaje/core'
import type { TRecord } from '@rehaje/shared'

export interface QueryModelConstructor {
  new (node: QueryNode): QueryModel
  definition?: TypedDefinitionConstructor
  node?: TypedNodeConstructor
}

export interface QueryPluginProps extends TRecord {
  /**
   * 默认自增 ID 前缀
   */
  defaultIncreaseKey?: string
  /**
   * 命名空间标识，确保是当前页面唯一标识
   */
  namespace?: string
  /**
   * 自定义查询扩展
   */
  queries?: Record<string, QueryModelConstructor>
}

export class QueryPlugin implements RehajePlugin {
  props: QueryPluginProps
  visitors: PluginVisitors

  constructor(props?: QueryPluginProps) {
    this.props = { ...props }
    this.visitors = this.__r_createVisitors()
  }

  __r_createVisitors() {
    const queries = this.props.queries ?? {}
    const visitors: RequiredPluginVisitors = {
      components: {},
      definitions: {
        Query: QueryDefinition,
        'Schema.Query': SchemaQueryDefinition
      },
      models: {
        Query: QueryModel
      },
      nodes: {
        Query: QueryNode
      }
    }
    for (const key of keys(queries)) {
      const type = `Query.${key}`
      const query = queries[key]
      if (query) {
        visitors.models[type] = query
        visitors.nodes[type] = query.node ?? QueryNode
        visitors.definitions[type] = query.definition ?? QueryDefinition
      }
    }
    return visitors
  }
}
